// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';

export { loadLeagueWidgets } from './league';
export { loadTeamWidgets } from './team';
export { loadEventWidgets } from './event';
export { loadPlayerWidgets } from './player';



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/loaders/index.js
 **/